import { useFinancialAccountState } from '@webapp/hooks'
import { FinancialAccountTypes } from '@webapp/platform/banking/entities/enums/FinancialAccountTypeEnum'
import { useLongTermScaVerificationPresenter } from '../presenters/LongTermScaVerificationPresenter'

export const useScaVerifiedContent = ({
  onError = () => undefined,
}: {
  onError?: () => void
} = {}) => {
  const {
    financialAccountType,
    isLoadingFinancialAccountSetupState,
    isFinancialAccountSetUp,
  } = useFinancialAccountState()

  const isScaVerificationEnabled =
    financialAccountType === FinancialAccountTypes.AIRWALLEX_GBP

  const {
    data: { scaToken },
    states: { isLoading: isLoadingScaState },
    commands: { verifyIdentity },
  } = useLongTermScaVerificationPresenter({
    enabled: isScaVerificationEnabled && isFinancialAccountSetUp,
    onError,
  })

  const showLoader =
    isScaVerificationEnabled &&
    (isLoadingFinancialAccountSetupState || isLoadingScaState || !scaToken)
  const showScaPrompt =
    isScaVerificationEnabled && !isLoadingScaState && !scaToken

  return {
    data: { scaToken },
    commands: { verifyIdentity },
    states: {
      showLoader,
      showScaPrompt,
      isVerified:
        !isLoadingFinancialAccountSetupState &&
        (!isScaVerificationEnabled || !!scaToken),
    },
  }
}
